import { isHeightConstrained } from '../../styles'
import type { Tokens } from '../../../../theming/types'

export default (config: { tokens: Tokens }) => {
  const { tokens } = config
  return {
    default: {
      bodyWrap: {
        flex: '1 1 auto',
        overflowY: 'auto',

        [isHeightConstrained]: {
          flex: '1 0 auto',
        },
      },

      body: {
        ...tokens.fontBodyM,
        overflowY: 'hidden',
      },

      shadowTop: {
        opacity: 0,
      },

      shadowBottom: {
        opacity: 0,
      },
    },

    noPadding: {
      body: {
        padding: 0,
      },
    },

    scrollShadow: {
      shadowTop: {
        opacity: 1,
      },

      shadowBottom: {
        opacity: 1,
      },
    },
  } as const
}
